/** @module Apparel/_NewStyleMixIn */
define([
	"dojo/_base/declare",
	"csi/xml",
	"csi/widget/LabeledImage",
	"Apparel/StructureItemMixin",
], function(declare, xml, LabeledImage, StructureItemMixin) {

	var PRODUCT_TEMPLATE = "Template";
	var PRODUCT_TYPE = "ProductType";

	return declare(StructureItemMixin, {
		defaultsAttribute: "StyleType",

		/**
		 * @override
		 * Overriding the method to add the rightWidget with image.
		 */
		onCreatePopup(view) {
			if (this.imageUrl) {
				view.rightWidgetProperties = {
					imageSrc: this.imageUrl,
				}
				view.rightWidgetClass = LabeledImage;
			}
		},

		/**
		 * @override
		 * Specify appropriate form info
		 */
		onCreateFormInfo(formInfo) {
			const parent = this.getParent();
			if (parent?.$Type === "Collection") {
				// this is needed to establish the appropriate context when creating a Style under the Collection->Styles tab (where the Relationship tag does not have an Id)
				formInfo.parentUrl = parent.$URL;
				formInfo.parentAttributeId = "Hierarchy";
			}
		},

		toWriterRequest: function() {
			// summary: call server Java operation to create Style with given type and template
			var formData = this.getFormData();

			// Create Style using server operation
			var call = this.inherited(arguments);
			call
				.addParameter(PRODUCT_TEMPLATE, xml.ATTR_REF, formData.getFieldValue(PRODUCT_TEMPLATE, true))
				.addParameter(PRODUCT_TYPE, xml.ATTR_REF, formData.getFieldValue(PRODUCT_TYPE, true));

			return call;
		}
	});
});